__turbopack_context__.v({
  "typography": "_KMoRW_typography",
});
